import React from 'react'

function AboutSE() {
  return (
      <div className="about-se">
            Software Engineer
    </div>
  )
}

export default AboutSE